import type { OrganizationEntity, OrganizationSlug } from "./organization.type";

export const findOrganizationBySlug = <
  Organization extends OrganizationEntity = OrganizationEntity,
>(
  slug?: OrganizationSlug,
  organizations?: Organization[]
) => {
  return organizations?.find((organization) => organization.slug === slug);
};

export const findOrganizationById = <
  Organization extends OrganizationEntity = OrganizationEntity,
>(
  id?: number,
  organizations?: Organization[]
) => {
  return organizations?.find((organization) => organization.id === id);
};
